import React from "react"
const CommonDesignJourney = ({ data }) => {
  const getImagesSection = isOnlyWebApp => {
    if (isOnlyWebApp) {
      return (
        <div className="self-end flex-grow  h-full w-[24rem] md:w-[50rem] xl:w-[45rem] flex flex-col gap-8 md:gap-4 xl:gap-6">
          <div className="flex-1  px-8 md:px-8 xl:px-12 pb-8  bg-white-200 rounded-b-[3rem]">
            <div className="grid grid-cols-1 w-full items-end h-full gap-y-6 md:gap-y-10 xl:gap-y-12  justify-center">
              <div className="">
                <img
                  src={data.topImage.url}
                  alt={data.topImage.label}
                  className=""
                  loading="lazy"
                />
              </div>
              <div className="px-4 md:px-4 xl:px-6   leading-tight text-center text-[1.08rem]  md:text-2xl text-gray-100 self-center tracking-[-.28px] md:tracking-[-0.96]">
                {data.topImage.topLabel
                  ? data.topImage.topLabel
                  : "The easiest way to buy gold online"}
              </div>
            </div>
          </div>
          <div className="flex-1 px-8 md:px-8 xl:px-12 pt-8  bg-white-200 rounded-t-[3rem]">
            <div className="grid  grid-cols-1 w-full items-start h-full gap-y-6 md:gap-y-10 xl:gap-y-12  justify-center">
              <div className="px-4 md:px-4 xl:px-6   leading-tight text-center text-[1.08rem]  md:text-2xl text-gray-100 self-center tracking-[-.28px] md:tracking-[-0.96]">
                {data.bottomImage.bottomLabel
                  ? data.bottomImage.bottomLabel
                  : "Easiest way to buy gold offline and online"}
              </div>
              <div className="">
                <img
                  src={data.bottomImage.url}
                  alt={data.bottomImage.label}
                  className=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className="self-end flex-grow h-full w-[24rem]   md:w-[50rem] xl:w-[45rem] flex flex-col gap-8 md:gap-4 xl:gap-6">
        <div className="flex-1 md:px-8 px-8 xl:px-12 pt-8  bg-white-200 rounded-b-[3rem]">
          <div className="grid grid-cols-2 w-full items-end h-full  justify-center">
            <div className=" -me-3 md:-me-3  xl-me-3">
              <img
                src={data.topImage.url}
                alt={data.topImage.label}
                className=""
                loading="lazy"
              />
            </div>
            <div className="px-4 xl:px-6  leading-tight text-center text-sm md:text-2xl text-gray-100 self-center tracking-[-.28px] md:tracking-[-0.96]">
              {data.topImage.topLabel
                ? data.topImage.topLabel
                : "The easiest way to buy gold online"}
            </div>
          </div>
        </div>
        <div className="flex-1 md:px-8 px-8 xl:px-12 pb-8  bg-white-200 rounded-t-[3rem]">
          <div className="grid  grid-cols-2 w-full items-start h-full  justify-center">
            <div className="px-4  xl:px-6 leading-tight text-center text-sm md:text-2xl text-gray-100 self-center tracking-[-.28px] md:tracking-[-0.96]">
              {data.bottomImage.bottomLabel
                ? data.bottomImage.bottomLabel
                : "Easiest way to buy gold offline and online"}
            </div>
            <div className="md:-ms-3   xl-ms-3">
              <img
                src={data.bottomImage.url}
                alt={data.bottomImage.label}
                className=""
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className="md:px-20 h-full md:pe-20 px-6 flex flex-col  ">
      <div className="items-center w-max  basis-full flex gap-32 md:gap-20 xl:gap-32 flex-row">
        <div className="flex w-[254px]  md:w-[480px] xl:w-[597px] flex-col gap-4 md:gap-10 ">
          <div className="flex flex-col items-start gap-4 w-full">
            <div className="flex items-center gap-2">
              <div className="bg-blue-100 w-2 h-2 rounded-full"></div>
              <h4
                className={`text-gray-500 text-lg lg:text-2xl tracking-[-0.56px] md:tracking-tight-4% `}
              >
                Process
              </h4>
            </div>
            <h2
              className={`text-gray-100 text-3xl md:text-5xl lg:text-8xl tracking-[-.96px] md:tracking-tight-2% lg:tracking-tight-7%`}
            >
              Design
            </h2>
            <div
              className={`text-[1.08rem] md:text-[1.125rem] mt-0 md:mt-6 xl:mt-8 text-start text-black-300 `}
            >
              {" "}
              {data.description}
            </div>
          </div>
        </div>
        {getImagesSection(data.isWebImage ? true : false)}
      </div>
    </div>
  )
}

export default CommonDesignJourney
